<template>
    <div id="addAdClusterContainer">
        <!-- ローディング画面を表示 -->
        <div class="addAdClusterMessage" v-show="this.$store.state.loading">
            <div>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1" v-show="this.$store.state.loading"></vue-loaders>
            </div>
        </div>
        <!-- 登録完了画面を表示 -->
        <div class="addAdClusterMessage" v-show="!this.$store.state.loading && this.$store.state.successful">
            <p>{{responseMessage}}</p>
            <a class="btn addAdClusterMessageBtn" @click="modalClose">閉じる</a>
        </div>
        <!-- 入力画面を表示 -->
        <div v-show="!this.$store.state.loading && !this.$store.state.successful">
            <div class="addAdClusterHeader">
                <div class="addAdClusterTitle">広告クラスタ 新規登録</div>
                <a class="btn closeBtn" @click="modalClose">×</a>
            </div>
            <div class="addAdClusterForm">
                <div class="addAdClusterLine">
                    <!-- <transition name="fade">
                        <div class="errorBalloon" v-if="errorMessage.AdClusterName !== ''">
                            <p>広告クラスタ名は必須入力です</p>
                        </div>
                    </transition> -->
                    <input class="adClusterInputText" type="text" placeholder="広告クラスタ名" v-model.trim="adClusterName">
                </div>
                <div class="addAdClusterLine">
                <transition name="fade">
                    <div class="errorBalloon" v-if="errorMessage.adClusterUrl !== ''">
                        <p>{{ errorMessage.adClusterUrl }}</p>
                    </div>
                </transition>
                    <input class="adClusterInputText" type="text" placeholder="URL" v-model.trim="adClusterUrl">
                </div>
                <p class="addAdClusterLine">
                    <a class="btn addAdClusterBtn" :class="{'notSelected': (adClusterName === '' || adClusterUrl === '')}" @click="addSubmit">登録</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreateAdCluster',
    data() {
        return {
            adClusterName: "",
            adClusterUrl: "",
            responseMessage: "",
            errorMessage: { adClusterUrl : ''}
        }
    },
    methods: {
        // adClusterNameとadClusterUrlは必須項目。入力しなければ登録ボタンが有効にならない。
        addSubmit() {
            if (!this.adClusterUrl.match(/^https?:\/\/[\w/:%#$&?()~.=+-]+/)) {
                this.errorMessage.adClusterUrl = 'URLの形式で入力してください。';
                return;
            }

            this.$store.dispatch("loading", true)
            // 入力した広告クラスタを送信
            this.axios.post("/api/adClusters", {
                adClusterName: this.adClusterName,
                adClusterUrl: this.adClusterUrl
            }).then((adClustersResponse) => {
                if(adClustersResponse.data.alreadyExistAdCluster) {
                    this.responseMessage = '既に登録済みのURLです。';
                } else {
                    this.responseMessage = '新しい広告クラスタが登録されました。';
                }
                // 広告クラスタリストを取得
                this.axios.get("/api/adClusters?page=1")
                .then((res) => {
                    this.responseData = res.data
                    this.$emit("updateAdClusters", this.responseData)
                    this.$store.dispatch("successful", true);
                }).catch(() => {
                })
            }).catch(() => {
                // this.responseMessage = 'ステータスコードから判定したエラーメッセージ'
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    }
}
</script>

<style scoped lang="sass">
#addAdClusterContainer
    height: 100%
    padding: 15px
    .addAdClusterMessage
        left: 50%
        position: absolute
        text-align: center
        top: 50%
        transform: translate(-50%, -50%)
        width: 100%
        p
            font-size: 2.5rem
        .addAdClusterMessageBtn
            border: 1px solid $whiteColor
            font-size: 1.3rem
            margin: 40px auto 0
            padding: 12px 10px
            width: 80px
            &:hover
                border: 1px solid $mainColor
    .addAdClusterHeader
        font-size: 2.0rem
        overflow: hidden
        padding: 5px
        position:relative
        text-align: center
        .addAdClusterTitle
            color: $grayColor
            left: 50%
            margin-top: 10px
            position: absolute
            transform: translateX(-50%)
        .closeBtn
            border: 1px solid $whiteColor
            display: block
            float: right
            font-size: 1.7rem
            margin-left: 5px
            padding: 10px 10px
            width: 40px
            &:hover
                border: 1px solid $mainColor
    .addAdClusterForm
        .addAdClusterLine
            color: $grayColor
            font-size: 1.2rem
            margin: 45px auto 0
            position: relative
            text-align: center
            width: 80%
            .errorBalloon
                padding: 4px
                position: absolute
                text-align: left
                bottom: 40px
                width: 80%
                margin: 8px
                &:before
                    border: 5px solid transparent
                    border-top: 10px solid #FDD
                    left: 12px
                    margin-left: 0px
                    position: absolute
                    bottom: -15px
                &:after
                    border: 7px solid transparent
                    border-top: 12px solid #ff0000
                    left: 10px
                    margin-left: 0px
                    position: absolute
                    bottom: -19px
            .fade-enter-active, .fade-leave-active
                transition: opacity 1s
            .fade-enter, .fade-leave-to
                opacity: 0
            .loginInputText
                border: 1px solid $grayColor
                padding: 10px
                width: 100%
                &:focus
                    outline: 2px solid $mainColor
            .adClusterInputText
                padding: 10px
                text-align: left
                width: 100%
                &:focus
                    outline: 2px solid $mainColor
            .addAdClusterBtn
                border: 1px solid $whiteColor
                font-size: 1.3rem
                margin: 0 auto
                padding: 12px 10px
                width: 80px
                &:hover
                    border: 1px solid $mainColor
            .notSelected
                background: #ccc
                pointer-events: none
</style>